<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      HrAwardTypes: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchHrAwardTypes: null,
      HrAwardTypesSearchMode: false,
      searchModel: "",
      // state: state,
    };
  },
  methods: {
    addHrAwardTypes() {
      // console.log("**********####", this.state);
      var data = {
        title: "popups.add",
        inputs: [
          {
            model: "name",
            type: "text",
            label: this.$t("hr_awards.name"),
            restrictions: { required: true },
          },
          {
            model: "name_en",
            type: "text",
            label: this.$t("hr_awards.name_en"),
            restrictions: { required: true },
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.post("hr-award-types", obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
    editHrAwardTypes(app) {
      var data = {
        title: "popups.edit",
        inputs: [
          {
            model: "name",
            type: "text",
            label: this.$t("hr_awards.name"),
            value: app.name,
          },
        ],
        buttons: [
          {
            text: "popups.edit",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.http.put("hr-award-types", app.id, obj).then(() => {
                this.get(this.page);
              });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },

    search(page) {
      this.HrAwardTypesSearchMode = true;
      this.tot_pages = 0;
      this.http
        .post("hr-award-types/search", {
          search: this.searchModel,
          limit: this.limit,
          page: page,
          col: "name",
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.HrAwardTypes = res.data;
          console.log("######## files", this.HrAwardTypes);
        });
    },
    cancelappsearchMode() {
      this.searchModel = "";
      this.HrAwardTypesSearchMode = false;
      this.get(this.page);
    },

    getHrAwardTypes() {
      this.http.get("hr-award-types").then((res) => {
        this.HrAwardTypes = res.data;
      });
    },
    deleteHrAwardTypes(app) {
      var data = {
        title: "popups.deletefile",
        msg: "popups.delmessage",
      };
      this.popup.confirm(data).then((resp) => {
        if (resp) {
          console.log("###");
          this.http.delete("hr-award-types", app.id).then(() => {
            this.get(this.page);
          });
        }
      });
    },

    get(page) {
      console.log(page);
      this.http
        .post("hr-award-types/pagination", {
          limit: this.limit,
          page: page,
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.HrAwardTypes = res.data;
        });
    },
  },
  created() {
    this.get(1);
    this.getHrAwardTypes();
  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.hr.subItems.awardstype')"
    />
    <div class="row">
      <div class="col-6">
        <div class="search-box chat-search-box w-50">
          <div class="position-relative">
            <input
              @input="search(page)"
              type="search"
              class="form-control fa-lg text-light"
              :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
              :placeholder="$t('popups.search')"
              v-model="searchModel"
              style="background-color: #2a3042 !important"
            />
            <i class="bx bx-search-alt search-icon text-light"></i>
          </div>
        </div>
      </div>
      <div class="col-6" style="display: flex; justify-content: flex-end">
        <!-- <button
          class="btn-close text-light"
          v-if="HrAwardTypesSearchMode"
          @click="cancelappsearchMode()"
        ></button> -->
        <button
          type="button"
          @click="addHrAwardTypes()"
          class="btn btn-light float-end mb-4"
        >
          <span
            class="bx bxs-plus-circle float-end fa-2x"
            style="color: #2a3042 !important"
          ></span>
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'" class="table">
        <thead>
          <tr
            class="text-light text-center"
            style="background-color: #2a3042 !important"
          >
            <th scope="col">{{ $t("hr_awards.id") }}</th>
            <th scope="col">{{ $t("hr_awards.name") }}</th>
            <th scope="col">{{ $t("hr_awards.created") }}</th>
            <th scope="col">{{ $t("hr_awards.updated") }}</th>
            <th scope="col">{{ $t("hr_awards.operations") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(app, index) in HrAwardTypes"
            :key="app"
            class="text-center"
          >
            <td>{{ (index += 1) }}</td>
            <td>{{ $i18n.locale == "en" ? app?.name_en : app?.name }}</td>
            <td>{{ app?.created?.split("T")[0] }}</td>
            <td>{{ app?.updated?.split("T")[0] }}</td>

            <td class="d-flex">
              <a
                class="btn btn-primary mx-1"
                @click="editHrAwardTypes(app)"
                href="javascript: void(0);"
                role="button"
                >{{ $t("popups.edit") }}</a
              >
              <a
                class="btn btn-danger"
                href="javascript: void(0);"
                role="button"
                @click="deleteHrAwardTypes(app)"
                >{{ $t("popups.delete") }}</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- end  table -->
    <!-- Button trigger modal -->

    <div>
      <!--   Apps  Pagination     -->
      <ul class="pagination pagination-rounded justify-content-center mb-2">
        <li class="page-item" :class="{ disabled: page == 1 }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="searchModel ? search(page - 1) : get(page - 1)"
            aria-label="Previous"
          >
            <i class="mdi mdi-chevron-left"></i>
          </a>
        </li>
        <li
          class="page-item"
          :class="{ active: p == page }"
          v-for="p in tot_pages"
          :key="p"
        >
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="searchModel ? search(p) : get(p)"
            >{{ p }}</a
          >
        </li>

        <li class="page-item" :class="{ disabled: page == tot_pages }">
          <a
            class="page-link"
            href="javascript: void(0);"
            @click="searchModel ? search(page + 1) : get(page + 1)"
            aria-label="Next"
          >
            <i class="mdi mdi-chevron-right"></i>
          </a>
        </li>
      </ul>
    </div>
    <!--end-->
  </Layout>
</template>

<style scoped>
.btn-close {
  position: relative;
  right: 317px;
  top: 6px;
  font-size: 15px;
}
</style>
